"use client";

import React from "react";
import { Card, CardContent, CardDescription, CardTitle } from "@/components/ui/card";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
const teamMembers = [{
  id: 1,
  name: "Marcus Thorne",
  role: "Chief Security Architect",
  bio: "Experte für Zero-Trust-Architekturen und CISSP-zertifizierter Berater mit 15 Jahren Erfahrung.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652372/img/expert_marcus_thorne.png",
  linkedin: "#",
  github: "#"
}, {
  id: 2,
  name: "Elias Vance",
  role: "NETWORK SECURITY ENGINEER",
  bio: "Spezialistin für Incident Response und Bedrohungserkennung in komplexen Enterprise-Umgebungen.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652372/img/expert_elias_vance.png",
  linkedin: "#",
  github: "#"
}, {
  id: 3,
  name: "Julian Kross",
  role: "Network Security Engineer",
  bio: "Fokus auf hochsichere Infrastrukturen und Cloud-Sicherheitsprotokolle für den Mittelstand.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652372/img/expert_julian_kross.png",
  linkedin: "#",
  github: "#"
}, {
  id: 4,
  name: "Sarah Miller",
  role: "Compliance & Risk Lead",
  bio: "Begleitet Unternehmen bei der ISO 27001 Zertifizierung und strategischen Risikobewertung.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652372/img/expert_sarah_miller.png",
  linkedin: "#",
  github: "#"
}];
export default function CreativeTeam() {
  return <section data-section-id="229774" id="das-experten-team" className="bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-30">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-primary/10 blur-[120px]" />
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-primary/5 blur-[120px]" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-default font-bold mb-4 tracking-tight uppercase">
            Das <span className="text-primary">Experten-Team</span>
          </h2>
          <p className="text-muted-foreground text-lg font-default">Unsere Spezialisten vereinen technologische Exzellenz mit strategischer Weitsicht für Ihre digitale Sicherheit.<br /><br />Unser Experten Team wird durch Pseudonymen dargestellt, um die Identität der einzelnen Personen zu schützen.</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {teamMembers.map((member, i) => <div key={member.id} data-index={i}>
              <TooltipProvider delayDuration={100}>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <div className="h-full cursor-pointer outline-none">
                      <Card className="h-full overflow-hidden group border-border/40 bg-card/30 backdrop-blur-md hover:border-primary/60 transition-all duration-500 shadow-xl hover:shadow-primary/20 rounded-lg">
                        <div className="relative aspect-[4/5] overflow-hidden bg-muted/20">
                          <img src={member.image} alt={member.name} className="object-cover w-full h-full grayscale group-hover:grayscale-0 transition-all duration-700 ease-in-out scale-100 group-hover:scale-105" />
                          {}
                          <div className="absolute inset-0 bg-primary/20 mix-blend-color-burn opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                          <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent opacity-60" />
                        </div>
                        <CardContent className="p-5 text-center relative z-20 bg-card/80 backdrop-blur-sm border-t border-border/30">
                          <CardTitle className="mb-1.5 text-lg font-default tracking-tight">
                            {member.name}
                          </CardTitle>
                          <CardDescription className="text-primary font-mono font-semibold text-xs uppercase tracking-widest">
                            {member.role}
                          </CardDescription>
                        </CardContent>
                      </Card>
                    </div>
                  </TooltipTrigger>
                  <TooltipContent side="bottom" sideOffset={10} className="p-5 max-w-[260px] bg-popover/95 backdrop-blur-xl border border-border shadow-4xl rounded-md z-50">
                    <p className="text-sm text-popover-foreground text-center leading-relaxed font-default">
                      {member.bio}
                    </p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            </div>)}
        </div>
      </div>
    </section>;
}